module.exports = __webpack_public_path__ + "img/l-cb6-r1.1ce64455.gif";